import type { SxProps, Theme } from '@mui/material';

export const starterRootSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
};

export const starterErrorSx: SxProps<Theme> = {
  marginTop: 2,
};

export const templateRowSx: SxProps<Theme> = {
  display: 'grid',
  gap: 8,
  // minmax(0, 1fr) rather than 1fr so the fixed-ratio preview block can never widen its track.
  gridTemplateColumns: {
    xs: 'minmax(0, 1fr)',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(3, minmax(0, 1fr))',
  },
  marginTop: 6,
};
